<script lang="ts" setup>
import { computed } from "vue";
import { useUserStore } from "@/stores/user";

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});
const userStore = useUserStore();

interface BreadcrumbItem {
  title?: string;
  text?: string;
  to?: string;
  params?: any;
}

const breadcrumbs = computed(() => {
  const list = [
    {
      'prepend-icon': "mdi-home",
      disabled: false,
      exact: true,
      title: "",
      to: { name: "Dashboard", params: { partyReference: userStore.currentPartyReference } },
      params: null,
    },
  ];

  if (Array.isArray(props.items)) {
    (props.items as BreadcrumbItem[]).forEach((element) => {
      if (element && (element.text || element.title)) {
        let toObj = undefined;
        if (element.to) {
          toObj = { name: element.to, params: element.params };
        }
        const item: any = {
          disabled: false,
          exact: true,
          title: (element.title || element.text) ?? '',
        };
        if (toObj) item.to = toObj;
        list.push(item);
      }
    });
  }
  return list;
});
</script>

<template>
  <v-breadcrumbs :items="breadcrumbs" class="inn-breadcrumbs">
    <template #prepend>
      <v-breadcrumbs-item
        :to="{ name: 'Dashboard', params: { partyReference: userStore.currentPartyReference } }"
        exact
        :disabled="breadcrumbs.length <= 1"
      >
        <v-icon size="medium">mdi-home</v-icon>
      </v-breadcrumbs-item>
    </template>
    <template v-slot:divider>
      <v-icon icon="mdi-chevron-right"></v-icon>
    </template>
  </v-breadcrumbs>
</template>
